"use strict";import{html as r}from"@cisco-u/base";export function roundedRectangle({height:e=293,width:t=251,hidden:l=!1,title:a="",fill:i="#C3C4C5"}={}){return r`<svg
    width=${t}
    height=${e}
    viewBox="0 0 251 293"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="${l?"true":"false"}"
    aria-label="${a}"
  >
    <path
      d="M0 101.543C0 45.4622 45.4622 0 101.543 0H148.608C204.688 0 250.15 45.4623 250.15 101.543V190.758C250.15 246.838 204.688 292.301 148.607 292.301H101.543C45.4622 292.301 0 246.838 0 190.758V101.543Z"
      fill=${i}
    />
  </svg>`}
//# sourceMappingURL=rounded-rectangle.js.map
